var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWingsSilver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0692 12.6242C11.3445 12.918 13.3296 13.842 14.7351 15.115C15.0294 15.3816 14.9198 16.2304 14.5674 16.4135C12.8847 17.2876 10.73 17.6771 8.45466 17.3833C6.17934 17.0894 4.1943 16.1654 2.7888 14.8924C2.49443 14.6258 2.60407 13.7771 2.95647 13.594C4.63921 12.7198 6.79388 12.3303 9.0692 12.6242Z",
    fill: "url(#paint0_linear_21983_223893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33267 9.43745C11.766 10.4924 13.6751 12.1545 14.8287 14.0185C15.0702 14.4089 14.6767 15.3166 14.2267 15.4071C12.0776 15.8393 9.55942 15.582 7.12616 14.527C4.69282 13.4721 2.78378 11.81 1.63015 9.94597C1.38861 9.55562 1.78213 8.64792 2.23217 8.55736C4.38125 8.12521 6.89933 8.38253 9.33267 9.43745Z",
    fill: "url(#paint1_linear_21983_223893)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1631 4.41415C12.6442 6.64472 14.2575 9.39016 14.8888 12.0746C15.021 12.6368 14.1889 13.5624 13.6158 13.4905C10.8795 13.1474 7.97857 11.8344 5.49747 9.60379C3.01637 7.37321 1.40312 4.62777 0.771829 1.9433C0.639624 1.38113 1.47171 0.455547 2.04475 0.527384C4.78098 0.870498 7.68202 2.18357 10.1631 4.41415Z",
    fill: "url(#paint2_linear_21983_223893)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9332 12.6242C24.6579 12.918 22.6728 13.842 21.2673 15.115C20.9729 15.3816 21.0826 16.2304 21.435 16.4135C23.1177 17.2876 25.2724 17.6771 27.5477 17.3833C29.823 17.0894 31.8081 16.1654 33.2136 14.8924C33.508 14.6258 33.3983 13.7771 33.0459 13.594C31.3632 12.7198 29.2085 12.3303 26.9332 12.6242Z",
    fill: "url(#paint3_linear_21983_223893)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6672 9.43745C24.2338 10.4924 22.3248 12.1545 21.1712 14.0185C20.9296 14.4089 21.3231 15.3166 21.7732 15.4071C23.9223 15.8393 26.4404 15.582 28.8737 14.527C31.307 13.4721 33.2161 11.81 34.3697 9.94597C34.6112 9.55562 34.2177 8.64792 33.7677 8.55736C31.6186 8.12521 29.1005 8.38253 26.6672 9.43745Z",
    fill: "url(#paint4_linear_21983_223893)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8373 4.41415C23.3562 6.64472 21.743 9.39016 21.1117 12.0746C20.9795 12.6368 21.8116 13.5624 22.3846 13.4905C25.1209 13.1474 28.0219 11.8344 30.503 9.60379C32.9841 7.37321 34.5973 4.62777 35.2286 1.9433C35.3608 1.38113 34.5287 0.455547 33.9557 0.527384C31.2195 0.870498 28.3184 2.18357 25.8373 4.41415Z",
    fill: "url(#paint5_linear_21983_223893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21983_223893",
    x1: 8.51956,
    y1: 13.5407,
    x2: 8.54927,
    y2: 15.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21983_223893",
    x1: 7.96613,
    y1: 9.84071,
    x2: 8.02472,
    y2: 13.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21983_223893",
    x1: 7.55124,
    y1: 3.17733,
    x2: 7.72808,
    y2: 8.84565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21983_223893",
    x1: 26.9981,
    y1: 13.5407,
    x2: 27.0278,
    y2: 15.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21983_223893",
    x1: 27.5071,
    y1: 9.84071,
    x2: 27.5657,
    y2: 13.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21983_223893",
    x1: 27.8911,
    y1: 3.17733,
    x2: 28.0679,
    y2: 8.84565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingsSilver);
export default __webpack_public_path__ + "static/media/wings_silver.d80b83fe9c25b7a3f65bbc28da6b86a8.svg";
export { ForwardRef as ReactComponent };